module.exports = __webpack_public_path__ + "img/story11-eisenstadt-5.jpg";